/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  RemoveCustomFieldProofMutationRequest,
  RemoveCustomFieldProofMutationResponse,
  RemoveCustomFieldProofPathParams,
} from "../types/RemoveCustomFieldProof.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const removeCustomFieldProofMutationKey = () =>
  [
    { url: "/v1/custom-field/remove-custom-field-proof/:customFieldValueId" },
  ] as const

export type RemoveCustomFieldProofMutationKey = ReturnType<
  typeof removeCustomFieldProofMutationKey
>

/**
 * @description Remove the proof of a custom field value
 * @summary Remove custom field proof
 * {@link /v1/custom-field/remove-custom-field-proof/:customFieldValueId}
 */
export async function removeCustomFieldProof(
  customFieldValueId: RemoveCustomFieldProofPathParams["customFieldValueId"],
  data: RemoveCustomFieldProofMutationRequest,
  config: Partial<RequestConfig<RemoveCustomFieldProofMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    RemoveCustomFieldProofMutationResponse,
    ResponseErrorConfig<Error>,
    RemoveCustomFieldProofMutationRequest
  >({
    method: "POST",
    url: `/v1/custom-field/remove-custom-field-proof/${customFieldValueId}`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function removeCustomFieldProofMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<RemoveCustomFieldProofMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = removeCustomFieldProofMutationKey()
  return mutationOptions<
    ResponseConfig<RemoveCustomFieldProofMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      customFieldValueId: RemoveCustomFieldProofPathParams["customFieldValueId"]
      data: RemoveCustomFieldProofMutationRequest
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ customFieldValueId, data }) => {
      return removeCustomFieldProof(customFieldValueId, data, config)
    },
  })
}

/**
 * @description Remove the proof of a custom field value
 * @summary Remove custom field proof
 * {@link /v1/custom-field/remove-custom-field-proof/:customFieldValueId}
 */
export function useRemoveCustomFieldProof<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<RemoveCustomFieldProofMutationResponse>,
      ResponseErrorConfig<Error>,
      {
        customFieldValueId: RemoveCustomFieldProofPathParams["customFieldValueId"]
        data: RemoveCustomFieldProofMutationRequest
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<RemoveCustomFieldProofMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? removeCustomFieldProofMutationKey()

  const baseOptions = removeCustomFieldProofMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<RemoveCustomFieldProofMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      customFieldValueId: RemoveCustomFieldProofPathParams["customFieldValueId"]
      data: RemoveCustomFieldProofMutationRequest
    },
    TContext
  >

  return useMutation<
    ResponseConfig<RemoveCustomFieldProofMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      customFieldValueId: RemoveCustomFieldProofPathParams["customFieldValueId"]
      data: RemoveCustomFieldProofMutationRequest
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<RemoveCustomFieldProofMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      customFieldValueId: RemoveCustomFieldProofPathParams["customFieldValueId"]
      data: RemoveCustomFieldProofMutationRequest
    },
    TContext
  >
}
